module.exports = __webpack_public_path__ + "img/7.966ae453.jpeg";